import React from 'react';
import Load from '@catalogo/ui-americanas-mobile-loading';
import { WrapperLoading, WrapperLoadingFullPage } from './Styled';

interface LoadingProps {
  fullPage?: boolean;
}

const Loading = (props: LoadingProps) => {
  const { fullPage } = props;

  if (fullPage) {
    return (
      <WrapperLoadingFullPage>
        <Load />
      </WrapperLoadingFullPage>
    );
  }

  return (
    <WrapperLoading>
      <Load />
    </WrapperLoading>
  );
};

Loading.defaultProps = {
  fullPage: false,
};

export default Loading;
export { Loading };
